import { DotLottieReact, type DotLottieReactProps } from '@lottiefiles/dotlottie-react';
import diceLoading from 'assets/dice_loading.json';
import { useAuth } from 'contexts/AuthContext';
import React, { useEffect, useState } from 'react';
import './SplashScreen.css';

// `@lottiefiles/dotlottie-react` type ses composants pour React 19 (`ReactNode`, qui autorise
// `undefined`) — incompatible avec les types React 18 de ce projet (`JSX.Element` strict) sans ce
// cast, alors que le composant fonctionne correctement à l'exécution dans les deux versions.
const DiceLottie = DotLottieReact as unknown as React.FC<DotLottieReactProps>;

interface SplashScreenProps {
  onComplete?: (isAuthenticated: boolean) => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        if (onComplete) {
          onComplete(isAuthenticated);
        }
      }, 500);
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, [onComplete, isAuthenticated]);

  return (
    <div
      className={`splash-screen${!isVisible ? ' fade-out' : ''}`}
      role='status'
      aria-live='polite'
      aria-label='Chargement de Faritany'
    >
      <DiceLottie className='splash-loader__lottie' data={diceLoading} loop autoplay />
    </div>
  );
};

export default SplashScreen;
